export default "__VITE_ASSET__DGL78kTk__"